import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
const CustomReadOnly = ({ label, labelStyle, content, contentStyle, contentBoxStyle, }) => {
    const theme = useTheme();
    if (!labelStyle)
        labelStyle = Object.assign(Object.assign({}, theme.typography.labelMedium), { color: theme.customColors.neutral.onSurfaceVariant });
    if (!contentStyle)
        contentStyle = Object.assign(Object.assign({}, theme.typography.bodyMedium), { color: theme.customColors.neutral.onSurface });
    if (!contentBoxStyle)
        contentBoxStyle = {
            width: "100%",
            height: "36px",
            borderRadius: "8px",
            gap: "10px",
            paddingTop: "6px",
            paddingRight: "16px",
            paddingBottom: "6px",
            paddingLeft: "16px",
            backgroundColor: theme.customColors.neutral.surfaceContainerLow,
        };
    return (_jsxs(Stack, { direction: "column", children: [_jsx(Typography, { sx: Object.assign({}, labelStyle), children: label }), _jsx(Box, { sx: Object.assign({}, contentBoxStyle), children: _jsx(Typography, { sx: Object.assign({}, contentStyle), children: content }) })] }));
};
export default CustomReadOnly;
